import { FavouriteCondition } from 'app/types-shared';
import { configuration } from 'app/components/filters/filters-panel/filter-types/configuration';

export const mapOptionType = (condition: FavouriteCondition): number => {

  const { advancedSearchType } = condition;

  const mapping = configuration
    .map(item => item.optionType)
    .filter(item => item)
    .reduce((result, optionType) => ({
      ...result,
      ...optionType(condition)
    }), {});

  return mapping[advancedSearchType];
};
